import { render, staticRenderFns } from "./SelectedFarmStringboxFarmCompariton.vue?vue&type=template&id=561a1868&scoped=true&"
import script from "./SelectedFarmStringboxFarmCompariton.vue?vue&type=script&lang=js&"
export * from "./SelectedFarmStringboxFarmCompariton.vue?vue&type=script&lang=js&"
import style0 from "./SelectedFarmStringboxFarmCompariton.vue?vue&type=style&index=0&id=561a1868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a1868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDatePicker,VMenu,VRow,VSpacer,VTextField})
